import { useState } from 'react';
import validator from 'validator'
import Input from '../../Input/Input';
import './FindWatches.css';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import leadApi from '../../../assets/api/leadApi';
import mainApi from '../../../assets/api/MainApi';
import { CrossIcon } from '../../../assets/icons/icons';

const DEFAULT_FORM = {
    name: '',
    phone: '',
    email: '',
    item_name: '',
}

const DEFAULT_FORM_VALIDITY = {
    phone: {},
    email: {},
}
function FindWatches() {
    const [submitPreloader, setSubmitPreloader] = useState(false)
    const [form, setForm] = useState(DEFAULT_FORM)

    const [formValidity, setFormValidity] = useState(DEFAULT_FORM_VALIDITY)


    function handleChange(e) {
        const input = e.target;
        const name = input.name;
        let value = input.value;

        switch (name) {
            case "phone":
                let inputValue = e.target.value.replace(/\D/g, '')
                let formattedInputValue = '';
                if (!inputValue) {
                    setForm(prevValue => ({
                        ...prevValue,
                        [name]: '',
                    }))
                    setFormValidity((prevValue) => ({
                        ...prevValue,
                        [name]: {
                            errorMessage: '',
                            validState: false
                        }
                    }))
                }
                else {
                    if (['7', '8', '9'].indexOf(inputValue[0]) > -1) {
                        setFormValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: '',
                                validState: false
                            }
                        }))
                        if (inputValue[0] === '9') inputValue = '7' + inputValue;

                        let firstSimbols = (inputValue[0] === '8') ? '8' : '+7';
                        formattedInputValue = firstSimbols + ' '

                        if (inputValue.length > 1) {
                            formattedInputValue += '(' + inputValue.substring(1, 4)
                        }
                        if (inputValue.length >= 5) {
                            formattedInputValue += ') ' + inputValue.substring(4, 7)
                        }
                        if (inputValue.length >= 8) {
                            formattedInputValue += '-' + inputValue.substring(7, 9)
                        }
                        if (inputValue.length >= 10) {
                            formattedInputValue += '-' + inputValue.substring(9, 11)
                        }
                        if (inputValue.length >= 11) {
                            setFormValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: '',
                                    validState: true
                                }
                            }));
                        } else {
                            setFormValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: '',
                                    validState: false
                                }
                            }));
                        }
                    } else {
                        formattedInputValue = '+' + inputValue.substring(0, 16)
                        if (inputValue.length >= 11) {
                            setFormValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: '',
                                    validState: true
                                }
                            }));
                        } else {
                            setFormValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: '',
                                    validState: false
                                }
                            }));
                        }
                    }


                    setForm(prevValue => ({
                        ...prevValue,
                        [name]: formattedInputValue,
                    }))
                }

                break;

            case "email":
                if (!value) {
                    setFormValidity((prevValue) => ({
                        ...prevValue,
                        [name]: {
                            errorMessage: "",
                            validState: false,
                        },
                    }));
                }
                if (value.length >= 2) {
                    if (validator.isEmail(value)) {
                        setFormValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: "",
                                validState: true,
                            },
                        }));
                    } else {
                        setFormValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: !e.target.validity.valid
                                    ? e.target.validationMessage
                                    : "Invalid email",
                                validState: false,
                            },
                        }));
                    }
                }
                setForm((prevValue) => ({
                    ...prevValue,
                    [name]: value,
                }));
                break;

            default:
                setForm((prevValue) => ({
                    ...prevValue,
                    [name]: value,
                }));
                break;
        }
    }


    function handlePhoneDelete(e) {
        if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length === 1) {
            setForm((prevValue) => ({
                ...prevValue,
                phone: '',
            }));
        }
        if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length < 11) {
            setFormValidity((prevValue) => ({
                ...prevValue,
                phone: {
                    errorMessage: '',
                    validState: false,
                },
            }));
        }
    }


    const [photos, setPhoto] = useState([]);

    // Функция для обработки изменения файла
    const uploadHandler = (e) => {
        const files = Array.from(e.target.files);
        // setIsPhotoLoading(true);

        function makeRequest(photo) {
            let data = new FormData();
            data.append("image", photo);

            return new Promise((resolve, reject) => {
                mainApi
                    .sendSellToUs({ data })
                    .then((res) => {
                        setPhoto((prevValue) => [...prevValue, res.urls.orig]);
                        resolve(res);
                        console.log(res, photos)
                    })
                    .catch((err) => {
                        console.log(err)
                    });
            });
        }

        const DEFAULT_MAX_IMG_SIZE = 15;
        async function runAsync(files) {
            for (let file of files) {
                // console.log(file);
                if (file && file.size / 1000000 >= DEFAULT_MAX_IMG_SIZE) return;

                await makeRequest(file).catch((err) => {
                    console.log(err);
                });
            }
        }

        runAsync(files).finally(() => {
            // console.log("FINISHED", photos);
            // const photosLength = product.photo.length + photos.length;
            // setIsPhotoLoading(false);
            // setProduct((prevValue) => ({
            //     ...prevValue,
            //     [name]: prevValue.photo ? prevValue.photo.concat(photos) : photos,
            // }));
            // setInfoValidity((prevValue) => ({
            //     ...prevValue,
            //     [name]: {
            //         errorMessage: photosLength <= 10 ? "" : null,
            //         //  ERROR_PHOTO_MAX_LENGTH,
            //         validState: photosLength <= 10,
            //     },
            // }));
        });


    }

    const isValid = form.name && form.email && formValidity.email.validState && form.phone && formValidity.phone.validState

    function sendRequest() {
        if (isValid) {
            setSubmitPreloader(true)
            mainApi.sendFindItem({
                email: form.email,
                name: form.name,
                phone: form.phone.replace(/\D/g, ''),
                item_name: form.item_name ? form.item_name : null,
                image_url: photos && photos.length > 0 ? photos[0] : null,
            })
                .then((res) => {
                    console.log(res)
                    setForm(DEFAULT_FORM)
                    setFormValidity(DEFAULT_FORM_VALIDITY)
                    setPhoto([])
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setSubmitPreloader(false)
                })
        }
    }

    function handlePhotoDelete() {
        setPhoto([])
    }
    return (
        <div className='find-watches'>
            <p className="find-watches__title">Не нашли нужные часы?</p>
            <p className="find-watches__subtitle"> Если в&nbsp;нашем каталоге нет интересующей вас модели, сообщите нам.
                Мы&nbsp;задействуем наши глобальные контакты и&nbsp;найдём именно те часы, которые вы&nbsp;ищете.</p>
            <div className='find-watches__form'>
                {/* <p>Request a Watch</p> */}
                <div className="personal-info__input">
                    <Input
                        label={"Название / Референс"}
                        value={form.item_name}
                        handleChange={handleChange}
                        name={"item_name"}
                    // error={formValid.email}
                    ></Input>
                </div>
                <div className="personal-info__input">
                    <Input
                        label={"Ваше имя*"}
                        value={form.name}
                        handleChange={handleChange}
                        name={"name"}
                    // error={formValid.email}
                    ></Input>
                </div>
                <div className="personal-info__input">
                    <Input
                        label={"Номер телефона*"}
                        value={form.phone}
                        handleChange={handleChange}
                        name={"phone"}
                        onKeyDown={handlePhoneDelete}
                    // error={formValid.email}
                    ></Input>
                </div>
                <div className="personal-info__input">
                    <Input
                        label={"Email*"}
                        value={form.email}
                        handleChange={handleChange}
                        name={"email"}
                    // error={formValid.email}
                    ></Input>
                </div>
                <div className="find-watches__photo-block find-watches__photo-block">
                    {photos.length > 0 ?
                        photos?.map((item, i) => {
                            return (
                                <div className='find-watches__photo-box'>
                                    <button className='find-watches__photo-box-delete' type='button' onClick={handlePhotoDelete}>
                                        <CrossIcon mainClassName={'find-watches__photo-box-delete-icon'} fillClassName={'find-watches__photo-box-delete-icon-fill'} />

                                    </button>
                                    <img key={i} src={item} alt="" className="find-watches__photo" ></img>
                                </div>
                            )
                        }) : null}
                    {photos.length === 0 ?
                        <div className="find-watches__add-photo">
                            <input onChange={uploadHandler} type="file" className="find-watches__add-photo__input" accept='image/png, image/webp, image/jpg, image/jpeg'></input>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <rect width="40" height="40" rx="20" fill="#F1F1F1" />
                                <path d="M20 14V26" stroke="black" stroke-width="2" stroke-linecap="round" />
                                <path d="M14 20L26 20" stroke="black" stroke-width="2" stroke-linecap="round" />
                            </svg>
                            Добавить фото
                        </div>
                        : null}
                </div>
                <button onClick={() => sendRequest()} className={`find-watches__submit-btn ${isValid ? 'find-watches__submit-btn_visible' : ''}`}>
                    {submitPreloader ? <MiniPreloader /> : 'Отправить запрос'}
                </button>
            </div>
        </div>
    );
}

export default FindWatches